import React, { useEffect, useContext, useState } from 'react'
import Section from '../../../UIcomponent/Section'
import Col from '../../../UIcomponent/Column'
import LocalContext from '../../../Context/LocalContetxt'
import './DashboardSessionStatistics.scss'
import { Title } from '../../../UIcomponent/Title'
import DashboardReq from '../../../Utility/Requester/DashboardReq'
const DashboardSessionStatistics = (props) => {
    const lang = useContext(LocalContext).lang
    const { role } = props
    const [Stats, setStats] = useState(null)
    useEffect(() => {
        if (role) {
            DashboardReq.SessionStats(role).then(res => {
                setStats(res.data)
            }).catch(err => {
            })
        }
    }, [])
    return (
        <Section
            lang={lang}
            justifyContent='space-evenly'
        >
            <Col
                className='c__DashboardSessionStatistics'
                xl={7} lg={7} md={7} sm={7} xs={7}
            >
                <Col
                    className='o__DashboardSessionStatistics__Value'
                >{Stats && Stats.ScheduledSessionsCount}</Col>
                <Title
                    center
                // className='o__DashboardSessionStatistics__Desc'
                >کلاس های پیش رو
                </Title>
                <Col
                    className='o__DashboardSessionStatistics__Desc--RES'
                >پیش رو
                </Col>
            </Col>
            {/* <Col
                xl={1} lg={1} md={1} sm={1} xs={1}
                className='o__Statistics__Divider'
            ></Col> */}
            <Col
                className='c__DashboardSessionStatistics'
                xl={7} lg={7} md={7} sm={7} xs={7}
            >
                <Col
                    className='o__DashboardSessionStatistics__Value'
                >{Stats && Stats.CompletedSessionsCount
                    }</Col>
                <Title
                    center
                >
                    کلاس های برگزار شده
                </Title>
                <Col
                    className='o__DashboardSessionStatistics__Desc--RES'
                >
                    برگزار شده
                </Col>
            </Col>
            {/* <Col
                xl={1} lg={1} md={1} sm={1} xs={1}
                className='o__Statistics__Divider'
            ></Col> */}
            <Col
                className='c__DashboardSessionStatistics'
                xl={7} lg={7} md={7} sm={7} xs={7}
            >
                <Col
                    className='o__DashboardSessionStatistics__Value'
                >{Stats && Stats.NotScheduledSessionsCount
                    }</Col>
                <Title
                    center
                >
                    کلاس های زمان بندی نشده
                </Title>
                <Col
                    className='o__DashboardSessionStatistics__Desc--RES'
                >
                    زمان بندی نشده
                </Col>
            </Col>
        </Section>
    )
}

export default DashboardSessionStatistics
